import { EmailDomainService as SchemaEmailDomainService } from '@weave/schema-gen-ts/dist/schemas/email/domain/v1/domain_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaEmailDomainV1Service = bindHTTP(SchemaEmailDomainService);
